import React, { useEffect } from "react";
import Helping from "../../helpers/Helping";
import Select from '../fields/dropDownWithSelect';
import MultiSelect from '../fields/dropDownWithMultiSelect';
import DropDownAutoFill from '../fields/dropDownAutoFill';
import Notification from "../layout/Notification";
import LoadingButton from '../fields/LoadingButton';

function ReportModal({ data, closeModal, removeNetworkError, error_message, error_type, btnIsDisable }) {

    const { searchTitle, search, searchShow, resetBtn, title, enable_date, statusData, typeData, paymentTypeData, blockchainData, reportName, maxDate, isReleased, enableSale, confirmedData, ownerAuctionData, idFilterShow, codeFilterShow, nameFilterShow, multiSelect } = data;

    return (
        <div class="actionModal modal fade" id="downloadReport" tabindex="-1" role="dialog" aria-labelledby="downloadReport" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <span class="reportTitle">
                            <h5 class="modal-title" id="exampleModalLongTitle">Download Report</h5>
                            <p>{title ? title : ''}</p>
                        </span>
                        <div class="closeFilter"
                            data-dismiss="modal"
                            onClick={(e) => closeModal(e)}
                        >
                            <span class="icon close">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                                    <g id="Group_189" data-name="Group 189" transform="translate(-1508.636 -183.636)"><rect id="Rectangle_292" data-name="Rectangle 292" width="1.886" height="15.085" rx="0.943" transform="translate(1508.636 184.969) rotate(-45)" fill="#fff"></rect><rect id="Rectangle_293" data-name="Rectangle 293" width="1.886" height="15.085" rx="0.943" transform="translate(1519.303 183.636) rotate(45)" fill="#fff"></rect></g>
                                </svg>
                            </span>
                        </div>
                    </div>

                    {error_message &&
                        <Notification
                            type={error_type}
                            message={error_message}
                            callback={removeNetworkError}
                        />
                    }
                    <div class="modal-body">
                        <div class="row">
                            {
                                searchShow && (
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group cardsearch mb-4">
                                            <span class="search-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                                    <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                                </svg>
                                            </span>
                                            <input class="form-control" type="search" placeholder={`Search in ${searchTitle}`} aria-label="Search" value={search} onChange={(e) => data.handleSearchChange(e)} />
                                        </div>
                                    </div>
                                )
                            }

                            {data.autocomplete && (
                                <div class="col-md-12 col-lg-12">
                                    <div class={`form-group ${data.field}`}>
                                        {/* <label for={data.field}>{data.autocompleteLabel}</label> */}
                                        <DropDownAutoFill
                                            label={data.autocompleteLabel}
                                            field={data.field}
                                            classes="col-md-12 col-lg-12"
                                            valuesArray={data.dataArray}
                                            handleOnSelect={(item) => data.handleOnSelect(item, data.field)}
                                            handleOnSearch={data.handleOnSearch}
                                            handleFormatResult={data.formatResult}
                                            handleOnClear={(item) => data.handleOnClear(data.field)}
                                            userSelectedFieldValue={data.value}
                                        />
                                    </div>
                                </div>
                            )}

                            {typeData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="type">Type</label>
                                        {multiSelect ? (
                                            <MultiSelect name="type" field="Type" id="type"
                                                valuesArray={typeData}
                                                callback={data.ref}
                                                userSelectedFieldValue={data.type}
                                                selectChangeFunction={data.handleMultiSelect}
                                            />
                                        ) : (
                                            <select class="form-select" id="type" name="type"
                                                value={data.type}
                                                onChange={(e) => data.handleValueChange(e)}>

                                                <option value="" selected>Select Type...</option>
                                                {typeData.map(t => (
                                                    <option value={t.value}>{Helping.getTitleCase(t.label)}</option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                            )}
                            {statusData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        {multiSelect ? (
                                            <MultiSelect name="status" field="Status" id="status"
                                                valuesArray={statusData}
                                                callback={data.ref}
                                                userSelectedFieldValue={data.status}
                                                selectChangeFunction={data.handleMultiSelect}
                                            />
                                        ) : (
                                            <select class="form-select" id="status"
                                                name="status"
                                                value={data.status}
                                                onChange={(e) => data.handleValueChange(e)}>
                                                <option value="" selected>Select Status...</option>
                                                {statusData.map(s => (
                                                    <option value={s.value}>{Helping.getTitleCase(s.name)}</option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                            )}
                            {enable_date && (
                                <>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="fromDate">From</label>
                                            <input type="date" max={maxDate ? maxDate : null} name="fromDate" id="fromDate" class="form-control" value={data.startDate} onChange={(e) => data.handleStartDateChange(e)} />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="toDate">To</label>
                                            <input type="date" max={maxDate ? maxDate : null} name="toDate" id="toDate" class="form-control" value={data.endDate} onChange={(e) => data.handleEndDateChange(e)} />
                                        </div>
                                    </div>
                                </>
                            )}
                            {paymentTypeData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="paymentType">Payment Type</label>
                                        {multiSelect ? (
                                            <MultiSelect name="payment_type" field="Payment Type" id="paymentType"
                                                valuesArray={paymentTypeData}
                                                callback={data.ref}
                                                userSelectedFieldValue={data.payment_type}
                                                selectChangeFunction={data.handleMultiSelect}
                                            />
                                        ) : (
                                            <select class="form-select" id="paymentType"
                                                name="payment_type"
                                                value={data.payment_type}
                                                onChange={(e) => data.handleValueChange(e)}>
                                                <option value="" selected>Select Payment Type...</option>
                                                {paymentTypeData.map(p => (
                                                    <option value={p.value}>{p.name}</option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                            )}
                            {blockchainData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="blockchain">Blockchain</label>
                                        {multiSelect ? (
                                            <MultiSelect name="blockchain" field="Blockchain" id="blockchain"
                                                valuesArray={blockchainData}
                                                callback={data.ref}
                                                userSelectedFieldValue={data.blockchain}
                                                selectChangeFunction={data.handleMultiSelect}
                                            />
                                        ) : (
                                            <select class="form-select" id="blockchain"
                                                name="blockchain"
                                                value={data.blockchain}
                                                onChange={(e) => data.handleValueChange(e)}>
                                                <option value="" selected>Select Blockchain...</option>
                                                {blockchainData.map(b => (
                                                    <option value={b.name}>{Helping.getTitleCase(b.name)}</option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                            )}
                            {enableSale && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="enablesale">On Sale</label>
                                        <select class="form-select" id="enablesale"
                                            name="enableSaleFilter"
                                            value={data.enableSaleFilter}
                                            onChange={(e) => data.handleValueChange(e)}>
                                            <option value="" selected>Select On Sale...</option>
                                            {enableSale.map(b => (
                                                <option value={b.value}>{Helping.getTitleCase(b.name)}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                            {isReleased && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="isreleased">Released/Unreleased </label>
                                        <select class="form-select" id="isreleased"
                                            name="releasedFilter"
                                            value={data.releasedFilter}
                                            onChange={(e) => data.handleValueChange(e)}>
                                            <option value="" selected>Select Released/Unreleased...</option>
                                            {isReleased.map(s => (
                                                <option value={s.value}>{Helping.getTitleCase(s.name)}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                            {confirmedData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="confirmed">Confirmed</label>
                                        <select class="form-select" id="confirmed"
                                            name="confirmedFilter"
                                            value={data.confirmedFilter}
                                            onChange={(e) => data.handleValueChange(e)}>
                                            <option value="" selected>Select Confirmed...</option>
                                            {confirmedData.map(s => (
                                                <option value={s.value}>{Helping.getTitleCase(s.name)}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            {ownerAuctionData && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="auctionType">Aution Type</label>
                                        <select class="form-select" id="auctionType"
                                            name="auctionType"
                                            value={data.auctionType}
                                            onChange={(e) => data.handleValueChange(e)}>
                                            <option value="" selected>Select Aution Type...</option>
                                            {ownerAuctionData.map(s => (
                                                <option value={s.value}>{Helping.getTitleCase(s.name)}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            {idFilterShow && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="idFilter">Id</label>
                                        <input type="text" name="idFilter" class="form-control" value={data.idFilter} onChange={(e) => data.handleValueChange(e)} />
                                    </div>
                                </div>
                            )}

                            {codeFilterShow && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="codeFilter">Code</label>
                                        <input type="text" name="codeFilter" class="form-control" value={data.codeFilter} onChange={(e) => data.handleValueChange(e)} />
                                    </div>
                                </div>
                            )}

                            {nameFilterShow && (
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="nameFilter">Name</label>
                                        <input type="text" name="nameFilter" class="form-control" value={data.nameFilter} onChange={(e) => data.handleValueChange(e)} />
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div class="modal-footer">
                        {
                            resetBtn ? <button type="button" class="custom-btn sm-btn semi-dark-btn" onClick={(e) => data.reset(e)} >Reset</button> : null

                        }
                        {btnIsDisable ?
                            <LoadingButton class_name={"sm-btn"} />
                            :
                            <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={() => data.getResults(reportName)}>Download</button>
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportModal;